import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-terminos-y-condiciones',
  templateUrl: './terminos-y-condiciones.component.html',
  styleUrls: ['./terminos-y-condiciones.component.css'],
})
export class TerminosYCondicionesComponent implements OnInit {
  mostrarModal = false;
  aceptaTerminos = false;

  checkAceptaTerminos = false;
  habilitarAceptar = false;

  @Input()
  tituloModal = '';

  @Input()
  cuerpoTexto: SafeHtml = '';

  @Input()
  mostrarBtnVolver = true;

  @Input()
  btnText = 'Suscribir medio de pago';

  @Input()
  textoCheckbox = '';

  @Input()
  mostrarCheckBox = true;

  @Output() aceptaTerminosChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {
    this.initModal();
  }

  initModal(): void {
    this.habilitarAceptar = !this.mostrarCheckBox;
  }

  onChangeCheckTerminos(): void {
    this.habilitarAceptar = this.checkAceptaTerminos;
  }

  abrirModal(): void {
    this.aceptaTerminos = false;
    this.mostrarModal = true;
  }

  cerrarModal(): void {
    this.aceptaTerminos = false;
    this.mostrarModal = false;
    this.aceptaTerminosChange.emit(this.aceptaTerminos);
  }

  aceptarTerminos(): void {
    this.aceptaTerminos = true;
    this.mostrarModal = false;
    this.aceptaTerminosChange.emit(this.aceptaTerminos);
  }
}
